var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentStructureTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_tree-view_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30 19 30 11 16 11 16 14 7 14 7 9 10 9 10 2 2 2 2 9 5 9 5 14 5 16 5 26 7 26 16 26 16 29 30 29 30 21 16 21 16 24 7 24 7 16 16 16 16 19 30 19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentStructureTree);
export default __webpack_public_path__ + "static/media/DocumentStructureTree.8e94447ac8355d2e22b82bc1c8dbbbc4.svg";
export { ForwardRef as ReactComponent };